import "@fontsource/montserrat/400.css"
import "@fontsource/montserrat/400-italic.css"
import "@fontsource/montserrat/600.css"
import "@fontsource/montserrat-alternates/400.css"
import "@fontsource/montserrat-alternates/600.css"
import Nav from "./nav"
import ProductFilter from "./product-filter"
import Readmore from "./readmore"
import Search from "./search"
import Slider from "./slider"
import ProductGallery from "./product-gallery"
import ProductVariation from "./product-variation"
import AddToCart from "./add_to_cart"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    ProductFilter(jQuery)
    ProductGallery(jQuery)
    Readmore(jQuery)
    Search(jQuery)
    Slider(jQuery)
    ProductVariation(jQuery)
    AddToCart(jQuery)
})
